import _ from 'lodash';

export type ReportExt = Record<string, any>;

export interface ReportPayload {
  eventId?: string;
  data?: {
    pageId?: string;
    buttonId?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

interface EmpContext {
  xdragon_employee_id?: string | number;
  xdragon_emp_code?: string | number;
  xdragon_employee_mobile?: string;
  employee_id?: string | number;
  emp_code?: string | number;
  dlr_code?: string;
  dlr_name?: string;
  org_group_name?: string;
  role_id?: string | number;
  main_position_group_name?: string;
  position_group_name?: string;
  org_position_flag?: string;
  pageFlag?: string;
}

function collectEmpContext(pageFlag: string): EmpContext {
  const userModule = (window as any).userModule;
  const emp = userModule?.employee ?? {};
  const loginRole = emp?.loginRole ?? {};
  const shopInfoList = userModule?.storeInfo?.shopInfoList ?? [];
  const firstShop = shopInfoList[0] ?? {};
  return {
    pageFlag,
    xdragon_employee_id: emp.id,
    xdragon_emp_code: emp.empCode,
    xdragon_employee_mobile: emp.mobile,
    employee_id: emp.id,
    emp_code: emp.empCode,
    dlr_code: firstShop.code ?? '',
    dlr_name: firstShop.simplifyName ?? '',
    org_group_name: loginRole.organizeName,
    role_id: loginRole.roleId,
    main_position_group_name: '',
    position_group_name: loginRole.positionName,
    org_position_flag: loginRole.positionFlag
  };
}

function resolvePageFlag(): string {
  try {
    const flattedMenus = (window as any).flattedMenus as any[] | undefined;
    if (!flattedMenus) return '';
    let pageFlag = '';
    flattedMenus.some(menu => {
      const route = `${menu.url.split('?')[0]}`;
      if (/:/.test(route)) {
        const pathList = window.location.pathname.split('/');
        if (route.split('/').every((path, index) => /^:/.test(path) || path === pathList[index])) {
          pageFlag = menu.permission;
          return true;
        }
      } else if (route.endsWith(window.location.pathname)) {
        pageFlag = menu.permission;
        return true;
      }
      return false;
    });
    return pageFlag;
  } catch {
    return '';
  }
}

class ReportService {
  public async report(payload: ReportPayload) {
    try {
      const { data = {}, ...rest } = payload;
      const { pageId = 'P10230', buttonId = 'B002' } = data as any;
      const pageFlag = resolvePageFlag();
      const empData = collectEmpContext(pageFlag);
      (data as any).pageFlag = pageFlag;

      if (!window.gdp) return;

      const reportParams: Record<string, any> = {
        ...empData,
        user_id: '',
        page_id: pageId,
        button_id: buttonId
      };
      Object.keys(data).forEach(key => {
        const v = (data as any)[key];
        reportParams[key] = _.isObject(v) ? JSON.stringify(v) : v;
      });
      Object.keys(rest).forEach(key => {
        const v = (rest as any)[key];
        reportParams[key] = _.isObject(v) ? JSON.stringify(v) : v;
      });

      window.gdp('setUserAttributes', empData);
      window.gdp('setGeneralProps', empData);
      window.gdp('track', payload.eventId || `INTL_xdragonWeb_${pageId}_${buttonId}`, reportParams);
    } catch (error) {
      console.error('report error', error);
    }
  }
}

export const ReportModule = new ReportService();

export function initReportModule() {
  window.reportModule = ReportModule;
}

export function reportV2(eventId = '', ext: ReportExt = {}) {
  try {
    if (window.reportModule?.report) {
      window.reportModule.report({ eventId, data: ext });
      return;
    }
    window.gdp?.('track', eventId, ext);
  } catch (e) {
    console.error('reportV2 error', e);
  }
}

export function report(payload: ReportPayload) {
  try {
    if (window.reportModule?.report) {
      window.reportModule.report(payload);
      return;
    }
    const { eventId = '', data = {}, ...rest } = payload;
    window.gdp?.('track', eventId, { ...data, ...rest });
  } catch (e) {
    console.error('report error', e);
  }
}
